import React, { ReactNode } from "react";
import { Card } from "@UI/Components/Card/Card";
import { Text } from "@UI/Components/Text/Text";
import { Flex } from "@UI/Components/Flex/Flex";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "./messages";

export interface ITrackingCard {
  type: "score" | "recurrent_client" | "total_clients";
  value: number | ReactNode;
  valueSubInfos?: ReactNode;
}

export const SingleTrackingCard = ({
  type,
  value,
  valueSubInfos,
}: ITrackingCard) => {
  return (
    <Card w="full" p={{ base: 4, md: 5 }} h="auto">
      <Flex flexDirection="column">
        <Text
          as="span"
          fontWeight={400}
          fontSize={{ base: "14px", md: "16px" }}
        >
          <FormattedMessage {...messages[type]} />
        </Text>
        <Text
          as="span"
          fontWeight={700}
          color="black"
          fontSize={{ base: "24px", md: "32px" }}
        >
          {value}
        </Text>
        <Text as="span" fontWeight={700} color="black">
          {valueSubInfos}
        </Text>
      </Flex>
    </Card>
  );
};
